import type { NarrativeForm } from '../../utils/schema';
import type { ValidationErrors } from '../../utils/validation';
import { useNarrativeTrackingField } from './hooks/useNarrativeTrackingField';

type Props = {
  trackEvent: (data: Record<string, string | number | boolean>) => void;
  dirty: Record<keyof NarrativeForm, boolean>;
  errors: ValidationErrors<NarrativeForm>;
};

export const useNarrativeTracking = ({ trackEvent, dirty, errors }: Props) => {
  useNarrativeTrackingField({
    trackEvent,
    hasError: Boolean(errors.fairValue),
    fieldName: 'fairValue',
    isModified: dirty.fairValue,
  });

  useNarrativeTrackingField({
    trackEvent,
    hasError: Boolean(errors.revenuePercentage),
    fieldName: 'revenuePercentage',
    isModified: dirty.revenuePercentage,
  });

  useNarrativeTrackingField({
    trackEvent,
    hasError: Boolean(errors.profitMarginPercentage),
    fieldName: 'profitMarginPercentage',
    isModified: dirty.profitMarginPercentage,
  });
  useNarrativeTrackingField({
    trackEvent,
    hasError: Boolean(errors.priceEarningsMultiple),
    fieldName: 'priceEarningsMultiple',
    isModified: dirty.priceEarningsMultiple,
  });

  useNarrativeTrackingField({
    trackEvent,
    hasError: Boolean(errors.discountRatePercentage),
    fieldName: 'discountRatePercentage',
    isModified: dirty.discountRatePercentage,
  });

  useNarrativeTrackingField({
    trackEvent,
    hasError: Boolean(errors.content),
    fieldName: 'content',
    isModified: dirty.content,
  });

  useNarrativeTrackingField({
    trackEvent,
    hasError: Boolean(errors.title),
    fieldName: 'title',
    isModified: dirty.title,
  });

  useNarrativeTrackingField({
    trackEvent,
    hasError: Boolean(errors.userHoldsPosition),
    fieldName: 'userHoldsPosition',
    isModified: dirty.userHoldsPosition,
  });
};
